import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import dayjs from 'dayjs'
import { useAppContext } from '../../../redux/slices/appContext'
import { useSearchMeetings } from '../../../api/wealthJourney'
import ClientMeeting from './ClientMeeting'

const useStyles = makeStyles((theme) => ({
  meetings: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.layout.gap.dense
  },
  noInfo: {
    padding: theme.layout.padding.thick,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--color-neutral-700)',
    fontWeight: theme.typography.weights.light
  }
}))

function ClientMeetings ({ relativeFrom, relativeTo, period, take }) {
  const classes = useStyles()
  const { clientId } = useAppContext()
  const query = useMemo(() => {
    const start = dayjs().add(relativeFrom, period).format('YYYY-MM-DD')
    const end = dayjs().add(relativeTo, period).format('YYYY-MM-DD')

    return {
      take,
      filters: {
        startDate: [{ op: 'gte', value: start }, { op: 'lte', value: end }],
        clientId: [{ op: 'eq', value: clientId }]
      }
    }
  }, [relativeFrom, relativeTo, period, take, clientId])
  const { data, isLoading } = useSearchMeetings(query)

  if (isLoading) return null

  if (!data?.data?.length) {
    return (
      <div className={classes.meetings}>
        <div className={classes.noInfo}>No Meetings</div>
      </div>
    )
  }

  return (
    <div className={classes.meetings}>
      {data.data.map(mtg => (
        <ClientMeeting key={mtg.meetingId} meeting={mtg} />
      ))}
    </div>
  )
}

ClientMeetings.propTypes = {
  relativeFrom: PropTypes.number,
  relativeTo: PropTypes.number,
  period: PropTypes.oneOf(['day', 'week', 'month', 'year']),
  take: PropTypes.number
}

ClientMeetings.defaultProps = {
  take: 3
}

export default ClientMeetings
